import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '16px',
  },
  text: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#61646B',
  },
  customOffsetStyles: {
    width: '5%',
  },
  prefixSuffixWrapper: {
    minWidth: '120px',
    maxWidth: '120px',
  },
  selectWrapper: {
    display: 'flex',
    gap: '20px',
    width: '100%',
  },
  buttonsWrapper: {
    display: 'flex',
    gap: '16px',
  },
  switchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'stretch',
    marginBottom: '20px',
    padding: '0 16px',
    '& .switchWrapperInner': {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));
